<template>
  <div>
    <v-radio-group v-model="searchType"
                   :column="$vuetify.breakpoint.smAndDown"
                   mandatory>
      <v-radio v-for="(type, index) in availableSearchTypes" :key="index"
               v-style:marginRight="$vuetify.breakpoint.xs ? 0 : '20px'"
               :value="type.id">
        <template #label>
          {{ type.text }}
        </template>
      </v-radio>
    </v-radio-group>
    <fin-data-loader-selector v-if="searchType === 'FAVORITES'"
                              key="FAVORITES"
                              :exclude-ids="excludeIds"
                              :resolver-function="loadFavorites"
                              label="Beliebte Vergleichsoptionen"
                              @input="val => result = val"/>

    <fin-data-loader-selector v-if="searchType === 'INDEX'"
                              key="INDEX"
                              :exclude-ids="excludeIds"
                              :resolver-function="loadIndices"
                              label="Index auswählen"
                              @input="val => result = val"/>

    <fin-data-loader-selector v-if="searchType === 'PORTFOLIO'"
                              key="PORTFOLIO"
                              :exclude-ids="excludeIds"
                              :resolver-function="loadUserPortfolios"
                              label="Portfolio auswählen"
                              @input="val => result = val"/>

    <fin-assets-name-isin-autocomplete v-if="searchType === 'SHARE_ETF'"
                                       :custom-result-mapping="customSearchResultMapping"
                                       :item-disabled="disableItems"
                                       asset-type="ALL"
                                       @input="val => result = val"/>
  </div>
</template>

<script>
import FinAssetsNameIsinAutocomplete from "@/components/common/AssetsNameIsinAutocomplete"
import FinDataLoaderSelector from "@/components/common/DataLoaderSelector"
import {listFavorites, listIndices, listUserPortfolios} from "@/components/common/GlobalSearch/graphql"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {mapGetters} from "vuex"

export default {
  name: "FinGlobalSearch",
  components: {FinDataLoaderSelector, FinAssetsNameIsinAutocomplete},
  props: {
    /** Hide the given ids from the dropdown + disable them at the share/etf search results */
    excludeIds: {
      type: Array
    },
    excludeInactive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchType: 'FAVORITES',
      availableSearchTypes: [{
        id: 'FAVORITES',
        text: 'Derzeit beliebt'
      }, {
        id: 'INDEX',
        text: 'Indizes'
      }, {
        id: 'PORTFOLIO',
        text: 'Meine Portfolios'
      }, {
        id: 'SHARE_ETF',
        text: 'Aktien/ETFs'
      }],
      result: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['userId']),
  },
  methods: {
    customSearchResultMapping(searchResults) {
      return searchResults.map(sr => sr.instrument)
    },
    disableItems(item) {
      let disable = this.excludeIds.includes(item.id)
      if(!disable && this.excludeInactive) {
        disable = !item.active || !item.covered || item.delisted
      }
      return disable
    },
    clearSearch() {
      this.searchType = 'INDEX'
      this.result = null
    },
    async loadIndices() {
      const result = await API.graphql(graphqlOperation(listIndices))

      return result.data.listIndexs.items
    },
    async loadUserPortfolios() {
      const result = await API.graphql(graphqlOperation(listUserPortfolios, {
        owner: this.userId
      }))

      return result.data.listPortfoliosByOwner.items
    },
    async loadFavorites() {
      const result = await API.graphql(graphqlOperation(listFavorites))

      return result.data.listFavorites.items
    },
  },
  watch: {
    result(val) {
      if (val !== null) {
        let type

        if (this.searchType === 'SHARE_ETF') {
          type = val.assetClass === 'SHARE' ? 'SHARE' : 'ETF'
        } else if (this.searchType === 'FAVORITES') {
          type = val.objectType
        } else {
          type = this.searchType
        }

        this.$emit('input', {
          type,
          typeLabel: this.availableSearchTypes.find(t => t.id === this.searchType).text,
          item: val
        })
      }
    },
    searchType() {
      // reset result if user changed the selected radio button
      this.result = null
      this.$emit('input', null)
    },
  },
}
</script>

<style scoped>

</style>
